import React from 'react';
import { Alert } from 'housecall-ui';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';

import { Layout } from './Layout';
import { StepProgressBar } from './StepProgressBar';

export const DataError = () => {
  return (
    <Layout
      Header={<StepProgressBar currentStep={1} stepCount={5} />}
      ContentComponent={
        <Alert severity="warning" role="status">
          Sorry, services are currently unavailable. Please try refreshing the page. If the issue persists, please
          don&apos;t hesitate to contact our support team for assistance.
        </Alert>
      }
      Buttons={
        <Button version="v2" size="large" fullWidth variant="contained" color="secondary" disabled>
          Next
        </Button>
      }
    />
  );
};
